import { Reveal } from "@/components/Reveal";

const COLS = [
  {
    title: "Servizi",
    links: [
      ["Menu Digitali", "#servizi"],
      ["Siti Web", "#servizi"],
      ["NFC", "#nfc"],
      ["Fotografia", "#servizi"],
      ["Video & Drone", "#servizi"],
    ],
  },
  {
    title: "Recensio",
    links: [
      ["Chi siamo", "#chi-siamo"],
      ["Portfolio", "#portfolio"],
      ["Contatti", "#contatti"],
    ],
  },
  {
    title: "Contatti",
    links: [
      ["recensio.it@gmail.com", "mailto:recensio.it@gmail.com"],
      ["@recensio.italia", "https://instagram.com/recensio.italia"],
    ],
  },
];

const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-[#C19D60]/10 bg-[#030303]">
    <div className="mx-auto max-w-[1440px] px-6 pb-10 pt-20 lg:px-12">
      <div className="grid gap-14 lg:grid-cols-5">
        <Reveal className="lg:col-span-2">
          <img src="/assets/recensio-logo.png" alt="Recensio" className="h-10 w-auto" />
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-[#A3A3A3]">
            Digital solutions for modern businesses.
          </p>
        </Reveal>
        {COLS.map((col) => (
          <Reveal key={col.title} delay={0.1}>
            <h4 className="mb-6 text-[11px] font-medium uppercase tracking-[0.3em] text-[#C19D60]">{col.title}</h4>
            <ul className="space-y-3.5">
              {col.links.map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="text-sm font-light text-[#A3A3A3] transition-colors duration-500 hover:text-[#E5CAA4]"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>

      <div className="mt-20 select-none overflow-hidden" aria-hidden="true">
        <p className="font-display whitespace-nowrap text-center text-[18vw] font-medium leading-none text-transparent lg:text-[13rem]" style={{ WebkitTextStroke: "1px rgba(193,157,96,0.12)" }}>
          Recensio
        </p>
      </div>

      <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 sm:flex-row">
        <p className="text-xs font-light text-[#666]">© {new Date().getFullYear()} Recensio. Tutti i diritti riservati.</p>
        <p className="flex gap-6 text-xs font-light text-[#666]">
          <a href="/privacy" data-testid="footer-privacy-link" className="transition-colors duration-500 hover:text-[#E5CAA4]">Privacy Policy</a>
          <a href="/cookie-policy" data-testid="footer-cookie-link" className="transition-colors duration-500 hover:text-[#E5CAA4]">Cookie Policy</a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
